import { OperationEnum, RawConditionValue } from '../operations/types';

export interface Condition {
  attribute: string;
  negate: boolean;
  op: OperationEnum;
  value: RawConditionValue;
}
